import { Inbox, RotateCcw } from 'lucide-react';
import { Button, Card, Drawer, Spinner, type OverlayTriggerState } from '@heroui/react';
import type { ParkingSpotOwner, SpotUsage } from '../../../api/my-parking-spots';
import { drawerBodyClassName, sideDrawerDialogClassName } from '../../../components/ui/side-drawer-classes';
import { StatusCallout } from '../../../components/ui/status-callout';
import { UsageHistoryCard } from '../../spot-usages/components/usage-history-card';

interface SpotUsagesDrawerProps {
  state: OverlayTriggerState;
  spot: ParkingSpotOwner | null;
  usages: SpotUsage[];
  loading: boolean;
  error: string | null;
  onReclaimUsage: (usageId: string) => void;
}

export function SpotUsagesDrawer({
  state,
  spot,
  usages,
  loading,
  error,
  onReclaimUsage,
}: SpotUsagesDrawerProps) {
  return (
    <Drawer state={state}>
      <Drawer.Backdrop isDismissable>
        <Drawer.Content placement="right">
          <Drawer.Dialog className={sideDrawerDialogClassName}>
            <Drawer.Header>
              <Drawer.Heading>Histórico de usos</Drawer.Heading>
              <Drawer.CloseTrigger />
            </Drawer.Header>

            <Drawer.Body className={drawerBodyClassName}>
              {spot ? (
                <p className="text-sm text-muted">
                  Vaga: <strong>{spot.spotCode}</strong>
                </p>
              ) : null}

              {error ? <StatusCallout status="danger">{error}</StatusCallout> : null}

              {loading ? (
                <div className="flex justify-center py-8">
                  <Spinner />
                </div>
              ) : usages.length === 0 ? (
                <Card>
                  <Card.Content className="flex flex-col items-center gap-2 p-8 text-center">
                    <Inbox size={40} className="text-muted" />
                    <p className="text-muted">Nenhum uso registrado para esta vaga.</p>
                  </Card.Content>
                </Card>
              ) : (
                <div className="space-y-3">
                  {usages.map((usage) => (
                    <UsageHistoryCard
                      key={usage.id}
                      usage={usage}
                      showRequester
                      showSpotCode={false}
                      actions={
                        usage.status === 'ACTIVE' ? (
                          <Button size="sm" variant="danger" onPress={() => onReclaimUsage(usage.id)}>
                            <RotateCcw size={14} />
                            Retomar vaga
                          </Button>
                        ) : undefined
                      }
                    />
                  ))}
                </div>
              )}
            </Drawer.Body>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
}
